import { Link } from "react-router-dom";
import "./footer.css";

export default function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-container">

        {/* BRAND */}
        <div className="footer-brand">
          <h3>ShareVideo</h3>
          <p>
            Watch videos, upload shorts and earn through impressions.
          </p>

          {/* PLAY STORE DOWNLOAD */}
          <div className="playstore-section">
            <a
              href="https://play.google.com/store/apps/details?id=com.sharevideo.sharevideo"
              target="_blank"
              rel="noopener noreferrer"
              className="playstore-link"
            >
              <img
                src="/google-play.png"
                alt="Get it on Google Play"
                className="playstore-img"
              />
            </a>
          </div>
        </div>

        {/* COMPANY */}
        <div className="footer-links">
          <h4>Company</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><a href="/contact.html">Contact</a></li>
            <li><a href="/account-deletion.html">Account Deletion</a></li>
          </ul>
        </div>

        {/* LEGAL */}
        <div className="footer-links">
          <h4>Legal</h4>
          <ul>
            <li><a href="/privacy-policy.html">Privacy Policy</a></li>
            <li><a href="/terms-and-conditions.html">Terms & Conditions</a></li>
            <li><a href="/dmca.html">DMCA Policy</a></li>
            <li><a href="/csae-policy.html">Child Safety</a></li>
          </ul>
        </div>

      </div>

      <div className="footer-bottom">
        � {new Date().getFullYear()} ShareVideo. All rights reserved.
      </div>
    </footer>
  );
}